import {view} from "@risingstack/react-easy-state";

export const NoFrameThemeSelector = view(() => {
    return null; // for now, won't have noFrame themes
});